import enterView from 'enter-view'
import WebFont from 'webfontloader'
import imagesLoaded from 'imagesloaded'
import Swiper from 'swiper/bundle'
import Vue from 'vue'
import ContactForm from '../vue/components/ContactForm.vue'

// UA-21110327-3
const { body, documentElement } = document
const hamburger = body.querySelector('.hamburger-menu')
const navigation = document.querySelector('.site-navigation')
const navigationItemActive = document.querySelectorAll(
  '.site-navigation > ul > li.menu-item-has-children'
)

export default {
  init() {
    WebFont.load({
      // google: {
      //   families: [
      //     'Prompt:200,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i&display=swap&subset=thai',
      //   ],
      // },
      custom: {
        families: ['RSU'],
      },
    })

    new Vue({
      el: '.ask-for-price',
      components: { ContactForm },
    })

    hamburger.addEventListener('click', (e) => {
      e.preventDefault()
      documentElement.classList.toggle('open-menu')
    })

    navigation.addEventListener('mouseover', (event) => {
      document.body.classList.add('hover-navigation')
    })

    navigation.addEventListener('mouseout', (event) => {
      document.body.classList.remove('hover-navigation')
    })

    navigationItemActive.forEach((element) => {
      element.addEventListener('mouseover', (event) => {
        document.body.classList.add('hover-navigation-item-active')
      })

      element.addEventListener('mouseout', (event) => {
        document.body.classList.remove('hover-navigation-item-active')
      })
    })

    let scrollPos = 0
    let timeout = null

    window.addEventListener('scroll', () => {
      if (body.getBoundingClientRect().top < 0) {
        body.classList.add('header-sticky')
      } else {
        body.classList.remove('header-sticky')
      }

      if (body.getBoundingClientRect().top > scrollPos) {
        body.classList.add('scrollup')
      } else if (body.getBoundingClientRect().top < scrollPos) {
        body.classList.remove('scrollup')
      }

      clearTimeout(timeout)

      timeout = setTimeout(function () {
        scrollPos = body.getBoundingClientRect().top
      }, 100)
    })
    // document.addEventListener('contextmenu', (event) => {
    //   if (!document.body.classList.contains('logged-in')) event.preventDefault()
    // })
  },
  finalize() {},
}
